import React, { useState, useEffect, useContext, Component } from 'react';
import { useNavigate, Link } from "react-router-dom";

import NavBar from '../../components/NavBar';
import HeaderPage from '../../components/HeaderPage';
import HeaderVendorPage from '../../components/HeaderVendorHome';


const VendorHome = () => {

    return (
        <>

            <HeaderVendorPage />

            <main className="page-content  mypadding bg-light overflow-auto pb-4" >


                <div className="w-100">
                    <div className="card-body p-4">
                        <h4 className="card-title text-center mb-4"> Dashboard</h4>
                        <div className="row">
                            {/* All Orders Option */}
                            <div className="col-6 mb-4">
                                <Link to="/all-order" className="card text-center p-3 shadow-sm rounded border">
                                    <i className="ri-list-check fs-3 text-primary mb-2"></i>
                                    <h5>All Asign Orders</h5>
                                </Link>
                            </div>

                            {/* Pending Orders Option */}
                            <div className="col-6 mb-4">
                                <Link to="/pending-order" className="card text-center p-3 shadow-sm rounded border">
                                    <i className="ri-hourglass-line fs-3 text-warning mb-2"></i>
                                    <h5>Pending Orders</h5>
                                </Link>
                            </div>

                            {/* Completed Orders Option */}
                            <div className="col-6 mb-4">
                                <Link to="/complete-order" className="card text-center p-3 shadow-sm rounded border">
                                    <i className="ri-checkbox-circle-line fs-3 text-success mb-2"></i>
                                    <h5>Completed Orders</h5>
                                </Link>
                            </div>

                            {/* Cancelled Orders Option */}
                            <div className="col-6 mb-4">
                                <Link to="/cancel-order" className="card text-center p-3 shadow-sm rounded border">
                                    <i className="ri-close-circle-line fs-3 text-danger mb-2"></i>
                                    <h5>Cancelled Orders</h5>
                                </Link>
                            </div>

                            {/* Profile Option */}
                            <div className="col-6 mb-4">
                                <Link to="/profile" className="card text-center p-3 shadow-sm rounded border">
                                    <i className="ri-user-line fs-3 text-info mb-2"></i>
                                    <h5>Profile</h5>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>


                <NavBar />

            </main>
        </>

    );
};

export default VendorHome